<template>
    <div class="portal-page-fill">
      <div class="gate-manager">
      <div class="top-header toolbar-card">
        <div class="search">
          <div class="icon">
            <span class="mdi mdi-magnify"></span>
          </div>
          <input
            class="search-bar"
            :placeholder="$t('search.auditplaceholder')"
             v-model="search"
          />
        </div>
      </div>
    </div>
         <div class="audit-reports portal-reports">
      <h6 class="report-title">
        {{ $t("audits.datepicker-title") }}
        <date-picker v-model="selectedDate" range :format="dateFormat" :placeholder="[[currentDate]] + ' ~ ' + [[currentDate]]"></date-picker>
        <input class="radio-btn" type="radio" id="PDF" value="pdf"  v-model="fileFormat"/>
        <label for="PDF">{{ $t("audits.pdf-btn") }}</label>
        <input class="radio-btn" type="radio" id="CSV"  value="csv" v-model="fileFormat"/>
        <label for="CSV">{{ $t("audits.csv-btn") }}</label>
        <input class="radio-btn" type="radio" id="EXCEL" value="xlsx" v-model="fileFormat"/>
        <label for="EXCEL">{{ $t("audits.excel-btn") }}</label>
        <button class="btn btn-primary float-right report-btn" @click="downloadReports">
          {{ $t("audits.download-btn") }}
        </button>
      </h6>
    </div>
        <div ref="auditTable" class="audit-table portal-table-wrap table-card">
          <div class="portal-table-scroll">
            <table class="table">
            <thead>
              <tr class="table-header">
                <th style="width: 7%;">{{ $t("audits.auditsTable.User") }}</th>
                <th style="width: 5%;">{{ $t("audits.auditsTable.Audit-Type") }}</th>
                <th style="width: 7%;">{{ $t("audits.auditsTable.Audit-ID") }}</th>
                <th style="width: 10%;">{{ $t("audits.auditsTable.Old-Values") }}</th>
                <th style="width: 10%;">{{ $t("audits.auditsTable.New-Values") }}</th>
                <th style="width: 7%;">{{ $t("audits.auditsTable.Event") }}</th>
                <th style="width: 10%;">{{ $t("audits.auditsTable.Time") }}</th>
                <th style="width: 7%;">{{ $t("audits.auditsTable.IP-Address") }}</th>
              </tr>
            </thead>
            <PortalTableBody :loading="loading" variant="audit" :show-actions="false">
              <tr v-for="(item,idx) in searchAudit" :key="idx">
                <td>{{ item.name }}</td>
                <td>
                  {{ auditType(item.auditable_type) }}
                  </td>
                  <td>{{ item.auditable_id }}</td>
                  <td class="oldData">{{ dataFormat(JSON.parse(item.old_values)) }}</td>
                  <td class="newData">{{ dataFormat(JSON.parse(item.new_values)) }}</td>
                <td>{{ item.event }}</td>
                <td>{{ timeFormat(item.created_at) }}</td>
                <td>{{ item.ip_address }}</td>
                
              </tr>
            </PortalTableBody>
          </table>
          </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import PortalTableBody from './PortalTableBody.vue';

export default {
  components: {
    DatePicker,
    PortalTableBody
  },
  data() {
    return {
      loading: false,
      data: {
        audit: [],
      },
      search: '',
      selectedDate: '',
      fileFormat: 'pdf',
      currentDate: '',
      dateFormat: 'YYYY-MM-DD',
      userName: ''
    };
  },
  computed: {
    searchAudit() {
      const rows = Array.isArray(this.data.audit) ? this.data.audit : [];
      if (!this.search) return rows;
      const q = this.search.toString().toLowerCase();
      return rows.filter((item) => {
        return (
          (item.event && item.event.toString().toLowerCase().includes(q)) ||
          (item.ip_address && item.ip_address.toString().toLowerCase().includes(q)) ||
          (item.updated_at && item.updated_at.toString().toLowerCase().includes(q)) ||
          (item.auditable_type && item.auditable_type.toString().toLowerCase().includes(q)) ||
          (item.name && item.name.toString().toLowerCase().includes(q)) ||
          (item.auditable_id != null && String(item.auditable_id).toLowerCase().includes(q))
        );
      });
    }
  },
  mounted() {
    const today = new Date();
    this.currentDate = moment(today).format(this.dateFormat);
    const storedUser = localStorage.getItem('username');
    this.userName = storedUser ? storedUser.replace(/['"]+/g, '') : '';
    this.loadAudit();
  },
  methods: {
    refreshPortalPage() {
      this.loadAudit();
    },
    loadAudit() {
      this.loading = true;
      axios
        .get(this.$hostName + '/audit')
        .then((response) => {
          const audit = response.data && response.data.audit;
          this.data.audit = Array.isArray(audit) ? audit : [];
        })
        .catch((error) => {
          console.log(error);
          this.data.audit = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    auditType(type) {
      if (!type) return '-';
      const parts = String(type).split('\\Models\\');
      return parts.length > 1 ? parts[1] : String(type).split('\\').pop() || type;
    },
    dataFormat(str) {
      if (str == null) {
        return '';
      }
      if (str.constructor && str.constructor.name === 'Array') {
        return '';
      }
      if (Object.prototype.hasOwnProperty.call(str, 'password')) {
        const copy = { ...str };
        copy.password = 'Encrypted Password';
        const myJSON = JSON.stringify(copy);
        return myJSON
          .replaceAll('"', '')
          .replaceAll('{', '')
          .replaceAll('}', '')
          .replaceAll('\\', '')
          .split(',')
          .join('\n');
      }
      if (typeof str === 'object' && Object.keys(str).length === 0) {
        return 'Encrypted Password';
      }
      const myJSON = JSON.stringify(str);
      return myJSON
        .replaceAll('"', '')
        .replaceAll('{', '')
        .replaceAll('}', '')
        .replaceAll('\\', '')
        .split(',')
        .join('\n');
    },
    timeFormat(time) {
      try {
        return moment(String(time)).format('YYYY-MM-DD hh:mm:ss');
      } catch (e) {
        return time;
      }
    },
    downloadReports() {
      const fromDate = moment(this.selectedDate[0]).format('YYYY-MM-DD');
      const toDate = moment(this.selectedDate[1]).format('YYYY-MM-DD');
      const fileType = this.fileFormat;
      const formData = {
        fDate: fromDate,
        tDate: toDate,
        filter: 'all',
        uName: this.userName,
        rName: 'Audit List',
        rType: 'audit',
        fType: fileType,
      };
      this.loading = true;
      axios({
        url: this.$hostName + '/downloadReport',
        method: 'POST',
        responseType: 'blob',
        data: formData,
      })
        .then((response) => {
          const binaryResponse = new Blob([response.data]);
          if (binaryResponse.size > 10) {
            const fileURL = window.URL.createObjectURL(binaryResponse);
            const fileLink = document.createElement('a');
            fileLink.href = fileURL;
            const fileName =
              'Audit_' +
              moment(new Date()).format('YYYY-MM-DD HH:mm:ss') +
              '.' +
              fileType;
            fileLink.setAttribute('download', fileName);
            document.body.appendChild(fileLink);
            fileLink.click();
            fileLink.remove();
          } else {
            this.$alert('No data for the selected filter criteria');
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.radio-btn {
  margin-left: 5%;
}

.report-btn {
  margin-right: 2%;
}

.oldData,
.newData {
  max-width: 200px;
  word-break: break-word;
  font-size: 11px;
  text-align: left;
}
</style>
